import moment, { Moment } from 'moment'
import { PreOrderSettings } from '@ancon/wildcat-types'

import { CompanyOrderHorizonMonths } from '../constants'
import { PreOrderSettingsWithHorizon } from '../types'

/**
 * The last day a company order can be placed for: the company horizon from
 * the pre-order settings, or the backend's fixed six months until they have it
 */
export default function getCompanyOrderMaxDate(
  preOrderSettings: PreOrderSettings | null | undefined,
  today: Moment = moment(),
) {
  const horizonMonths =
    (preOrderSettings as PreOrderSettingsWithHorizon | null | undefined)
      ?.companyHorizonMonths || CompanyOrderHorizonMonths

  return today.clone().add(horizonMonths, 'months').endOf('day')
}
